(() => {
  "use strict";

  /* ==================================================
     CÓDIGOS BRAND
     LOADER + LIVE CODING BACKGROUND
     ================================================== */


  /* ==================================================
     1. LOADING SCREEN
     ================================================== */

  const loader = document.getElementById("CodigosLoader");

  const messageText = document.querySelector(
    ".codigos-loader__message-text"
  );

  /*
   * Tiempo mínimo visible.
   *
   * 2000 = 2 segundos
   * 1500 = 1.5 segundos
   * 1000 = 1 segundo
   */
  const MINIMUM_LOADER_TIME = 2000;

  let loaderShownAt = null;


  /*
   * Solo inicializamos la lógica del loader
   * si realmente existe en la página.
   */
  if (loader) {

    /*
     * Si Liquid cargó inicialmente el loader activo,
     * comenzamos a contar inmediatamente.
     */
    if (loader.classList.contains("is-active")) {
      loaderShownAt = performance.now();
    }


    const messages = {
      product: "LOADING PRODUCT DATA...",
      collection: "ACCESSING COLLECTION DATABASE...",
      cart: "OPENING SECURE CART...",
      search: "SEARCHING DATABASE...",
      default: "INITIALIZING CÓDIGOS SYSTEM..."
    };


    /**
     * Oculta el loader respetando siempre
     * el tiempo mínimo configurado.
     */
    const hideLoader = () => {

      if (!loader.classList.contains("is-active")) {
        return;
      }

      const elapsedTime = loaderShownAt
        ? performance.now() - loaderShownAt
        : MINIMUM_LOADER_TIME;

      const remainingTime = Math.max(
        MINIMUM_LOADER_TIME - elapsedTime,
        0
      );

      window.setTimeout(() => {

        loader.classList.remove("is-active");

        loader.setAttribute(
          "aria-hidden",
          "true"
        );

        loaderShownAt = null;

      }, remainingTime);
    };


    /**
     * Muestra el loader.
     */
    const showLoader = (message) => {

      if (messageText && message) {
        messageText.textContent = message;
      }

      /*
       * Cada vez que aparece nuevamente,
       * reiniciamos el cronómetro.
       */
      loaderShownAt = performance.now();

      loader.classList.add("is-active");

      loader.setAttribute(
        "aria-hidden",
        "false"
      );
    };


    /**
     * Identifica hacia qué tipo de página
     * se dirige el usuario.
     */
    const getDestinationType = (url) => {

      const path =
        url.pathname.toLowerCase();

      if (path.includes("/products/")) {
        return "product";
      }

      if (path.includes("/collections/")) {
        return "collection";
      }

      if (path.includes("/cart")) {
        return "cart";
      }

      if (path.includes("/search")) {
        return "search";
      }

      return "default";
    };


    /**
     * Determina qué enlaces utilizarán
     * nuestra transición.
     */
    const shouldHandleLink = (
      link,
      event
    ) => {

      if (!link || !link.href) {
        return false;
      }

      /*
       * No intervenimos con:
       * CTRL + click
       * CMD + click
       * Shift
       * etc.
       */
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return false;
      }


      /*
       * No tocar enlaces que abren
       * ventanas nuevas o descargan archivos.
       */
      if (
        link.target === "_blank" ||
        link.hasAttribute("download")
      ) {
        return false;
      }


      const rawHref =
        link.getAttribute("href");


      /*
       * No tocar anchors, teléfonos o emails.
       */
      if (
        !rawHref ||
        rawHref.startsWith("#") ||
        rawHref.startsWith("mailto:") ||
        rawHref.startsWith("tel:") ||
        rawHref.startsWith("javascript:")
      ) {
        return false;
      }


      const destination = new URL(
        link.href,
        window.location.href
      );


      /*
       * No intervenir enlaces externos.
       */
      if (
        destination.origin !==
        window.location.origin
      ) {
        return false;
      }


      /*
       * No recargar exactamente la misma URL.
       */
      if (
        destination.pathname ===
          window.location.pathname &&
        destination.search ===
          window.location.search
      ) {
        return false;
      }


      const destinationType =
        getDestinationType(destination);


      /*
       * Loader solamente para estas páginas.
       */
      return [
        "product",
        "collection",
        "cart",
        "search"
      ].includes(destinationType);
    };


    /**
     * Oculta el loader inicial cuando
     * el DOM esté disponible.
     */
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        hideLoader();
      }
    );


    /**
     * Corrige el estado al regresar
     * utilizando Atrás/Adelante.
     */
    window.addEventListener(
      "pageshow",
      () => {
        hideLoader();
      }
    );


    /**
     * Transición antes de navegar.
     */
    document.addEventListener(
      "click",
      (event) => {

        const link =
          event.target.closest("a");

        if (
          !shouldHandleLink(
            link,
            event
          )
        ) {
          return;
        }


        const destination = new URL(
          link.href,
          window.location.href
        );


        const destinationType =
          getDestinationType(
            destination
          );


        event.preventDefault();


        showLoader(
          messages[destinationType] ||
          messages.default
        );


        /*
         * Esperamos solamente un momento
         * antes de iniciar la navegación.
         *
         * El loader continuará visible en
         * la página siguiente hasta cumplir
         * su mínimo de 2 segundos.
         */
        window.setTimeout(() => {

          window.location.href =
            destination.href;

        }, 300);

      }
    );

  }



  /* ==================================================
     2. EFECTO "LIVE CODING"
     ==================================================

     Este reemplaza la lluvia vertical Matrix.

     Ahora aparecen líneas de código que:

     1. Se escriben letra por letra.
     2. Permanecen visibles.
     3. Se borran.
     4. Aparecen nuevamente en otra ubicación.

     ================================================== */


  const initCodigosCodingCanvas = (
    canvas
  ) => {

    if (
      !canvas ||
      canvas.dataset.codingInitialized ===
        "true"
    ) {
      return;
    }


    canvas.dataset.codingInitialized =
      "true";


    const context =
      canvas.getContext("2d");


    if (!context) {
      return;
    }



    /* ==================================================
       FRASES / CÓDIGO
       Puedes añadir o eliminar las que quieras.
       ================================================== */

    const snippets = [

      '> SYSTEM ONLINE // CODIGOS',

      'const identity = "AUTHENTIC";',

      'style.decode();',

      'user.access = true;',

      'collection.load();',

      'product.render();',

      'identity.verify();',

      'if (original) { standOut(); }',

      'wear("CONFIDENCE");',

      'CODE_01.status = "ACTIVE";',

      'AUTHORIZATION: GRANTED',

      'SYS://CODIGOS/ONLINE',

      'decode(yourStyle);',

      'design.execute();',

      'profile.identity = "UNIQUE";',

      'ACCESS_LEVEL = 01;',

      'launchCollection();',

      'console.log("CODIGOS");',

      'SYSTEM READY_',

      'function createIdentity() {',

      'return ORIGINAL_STYLE;',

      'database.connect();',

      'catalog.sync();',

      'USER_PROFILE = VERIFIED;',

      'CODIGOS.initialize();',

      'status = "ONLINE";',

      'style !== ordinary;',

      'identity.load();',

      'executeCollection();',

      'AUTH_TOKEN: VALID'

    ];



    /* ==================================================
       COLORES
       ================================================== */

    const accentColor = {
      r: 0,
      g: 255,
      b: 102
    };


    const grayColor = {
      r: 104,
      g: 110,
      b: 125
    };



    let width = 0;
    let height = 0;

    let pixelRatio = 1;

    let lines = [];

    let animationFrame = null;



    /* ==================================================
       UTILIDADES
       ================================================== */

    const randomBetween = (
      minimum,
      maximum
    ) => {

      return (
        minimum +
        Math.random() *
        (maximum - minimum)
      );

    };


    const randomSnippet = () => {

      return snippets[
        Math.floor(
          Math.random() *
          snippets.length
        )
      ];

    };



    /* ==================================================
       CREA UNA LÍNEA DE CÓDIGO
       ================================================== */

    const createLine = (
      index = 0
    ) => {

      /*
       * Fuente ligeramente más pequeña
       * en móvil.
       */
      const fontSize =
        window.innerWidth < 750
          ? randomBetween(10, 13)
          : randomBetween(11, 15);


      /*
       * Evitamos que aparezca demasiado
       * cerca de los bordes.
       */
      const safeWidth =
        Math.max(
          80,
          width - 340
        );


      return {

        text:
          randomSnippet(),

        visibleCharacters: 0,


        x:
          randomBetween(
            20,
            safeWidth
          ),


        y:
          randomBetween(
            35,
            Math.max(
              70,
              height - 35
            )
          ),


        fontSize,


        /*
         * Menor número =
         * escribe más rápido.
         */
        typingSpeed:
          randomBetween(
            28,
            65
          ),


        deletingSpeed:
          randomBetween(
            14,
            28
          ),


        /*
         * Tiempo que permanece
         * completamente escrita.
         */
        holdTime:
          randomBetween(
            1800,
            4200
          ),


        lastUpdate:
          performance.now() +
          index * 300 +
          Math.random() * 1000,


        state:
          "typing",


        /*
         * Opacidad individual.
         *
         * El objetivo es que el fondo
         * sea decorativo, no invasivo.
         */
        opacity:
          randomBetween(
            0.16,
            0.38
          ),


        /*
         * Algunas líneas verdes,
         * otras grises.
         */
        useAccent:
          Math.random() > 0.32

      };

    };



    /* ==================================================
       CREA LAS LÍNEAS SEGÚN DISPOSITIVO
       ================================================== */

    const createLines = () => {

      let amount;

      if (width < 600) {

        amount = 5;

      } else if (width < 1000) {

        amount = 7;

      } else if (width < 1500) {

        amount = 10;

      } else {

        amount = 13;

      }


      lines = Array.from(
        {
          length: amount
        },
        (_, index) =>
          createLine(index)
      );

    };



    /* ==================================================
       REDIMENSIONAR CANVAS
       ================================================== */

    const resizeCanvas = () => {

      pixelRatio =
        Math.min(
          window.devicePixelRatio || 1,
          2
        );


      /*
       * Si el canvas tiene tamaño propio,
       * utilizamos ese tamaño.
       *
       * Si no, utilizamos la ventana.
       */
      width =
        canvas.clientWidth ||
        window.innerWidth;


      height =
        canvas.clientHeight ||
        window.innerHeight;


      canvas.width =
        Math.floor(
          width * pixelRatio
        );


      canvas.height =
        Math.floor(
          height * pixelRatio
        );


      canvas.style.width =
        `${width}px`;


      canvas.style.height =
        `${height}px`;


      context.setTransform(
        pixelRatio,
        0,
        0,
        pixelRatio,
        0,
        0
      );


      createLines();

    };



    /* ==================================================
       REINICIA UNA LÍNEA
       ================================================== */

    const resetLine = (
      line
    ) => {

      const newLine =
        createLine();


      Object.assign(
        line,
        newLine
      );


      /*
       * Pequeña pausa antes de
       * comenzar nuevamente.
       */
      line.lastUpdate =
        performance.now() +
        randomBetween(
          300,
          1500
        );

    };



    /* ==================================================
       CURSOR
       ================================================== */

    const drawCursor = (
      x,
      y,
      fontSize,
      opacity
    ) => {

      context.fillStyle =
        `rgba(
          ${accentColor.r},
          ${accentColor.g},
          ${accentColor.b},
          ${opacity}
        )`;


      context.fillRect(
        x + 3,
        y - fontSize + 2,
        Math.max(
          4,
          fontSize * 0.38
        ),
        fontSize
      );

    };



    /* ==================================================
       DIBUJAR
       ================================================== */

    const render = (
      time
    ) => {

      /*
       * Fondo transparente.
       *
       * Muy importante:
       * ya NO creamos estelas verticales.
       */
      context.clearRect(
        0,
        0,
        width,
        height
      );


      lines.forEach(
        (line) => {


          /* ==========================================
             ESCRIBIENDO
             ========================================== */

          if (
            line.state ===
            "typing"
          ) {

            if (
              time -
                line.lastUpdate >
              line.typingSpeed
            ) {

              line.visibleCharacters++;

              line.lastUpdate =
                time;


              if (
                line.visibleCharacters >=
                line.text.length
              ) {

                line.visibleCharacters =
                  line.text.length;

                line.state =
                  "holding";

                line.lastUpdate =
                  time;

              }

            }

          }


          /* ==========================================
             ESPERANDO
             ========================================== */

          else if (
            line.state ===
            "holding"
          ) {

            if (
              time -
                line.lastUpdate >
              line.holdTime
            ) {

              line.state =
                "deleting";

              line.lastUpdate =
                time;

            }

          }


          /* ==========================================
             BORRANDO
             ========================================== */

          else if (
            line.state ===
            "deleting"
          ) {

            if (
              time -
                line.lastUpdate >
              line.deletingSpeed
            ) {

              /*
               * Borra 1-2 caracteres
               * cada vez.
               */
              line.visibleCharacters -=
                2;


              line.lastUpdate =
                time;


              if (
                line.visibleCharacters <=
                0
              ) {

                resetLine(
                  line
                );

                return;

              }

            }

          }



          const visibleText =
            line.text.substring(
              0,
              Math.max(
                line.visibleCharacters,
                0
              )
            );



          /* ==========================================
             TIPOGRAFÍA
             ========================================== */

          context.font =
            `${line.fontSize}px monospace`;


          context.textBaseline =
            "alphabetic";


          context.textAlign =
            "left";



          /* ==========================================
             COLOR
             ========================================== */

          if (
            line.useAccent
          ) {

            context.fillStyle =
              `rgba(
                ${accentColor.r},
                ${accentColor.g},
                ${accentColor.b},
                ${line.opacity}
              )`;


            context.shadowColor =
              "rgba(0,255,102,0.30)";


            context.shadowBlur =
              5;

          } else {

            context.fillStyle =
              `rgba(
                ${grayColor.r},
                ${grayColor.g},
                ${grayColor.b},
                ${Math.min(
                  line.opacity + 0.10,
                  0.55
                )}
              )`;


            context.shadowBlur =
              0;

          }



          context.fillText(
            visibleText,
            line.x,
            line.y
          );



          /* ==========================================
             CURSOR PARPADEANTE
             ========================================== */

          if (
            line.state ===
              "typing" &&
            Math.floor(
              time / 430
            ) %
              2 ===
              0
          ) {

            const textWidth =
              context.measureText(
                visibleText
              ).width;


            drawCursor(
              line.x +
                textWidth,
              line.y,
              line.fontSize,
              Math.min(
                line.opacity +
                  0.28,
                0.72
              )
            );

          }


          context.shadowBlur =
            0;

        }
      );


      animationFrame =
        window.requestAnimationFrame(
          render
        );

    };



    /* ==================================================
       ACCESIBILIDAD
       ================================================== */

    const reducedMotion =
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;



    resizeCanvas();



    /*
     * Solamente animamos si el usuario
     * no tiene Reduce Motion activo.
     */
    if (!reducedMotion) {

      animationFrame =
        window.requestAnimationFrame(
          render
        );

    } else {

      /*
       * Para Reduce Motion mostramos
       * unas pocas líneas estáticas.
       */
      lines.forEach(
        (line) => {

          context.font =
            `${line.fontSize}px monospace`;

          context.fillStyle =
            "rgba(104,110,125,0.25)";

          context.fillText(
            line.text,
            line.x,
            line.y
          );

        }
      );

    }



    /*
     * Resize con debounce sencillo.
     */
    let resizeTimer;


    window.addEventListener(
      "resize",
      () => {

        window.clearTimeout(
          resizeTimer
        );


        resizeTimer =
          window.setTimeout(
            resizeCanvas,
            150
          );

      }
    );



    /*
     * Guardamos cleanup por si luego
     * queremos reutilizarlo en secciones
     * dinámicas de Shopify.
     */
    canvas._codigosCodingCleanup =
      () => {

        if (animationFrame) {

          window.cancelAnimationFrame(
            animationFrame
          );

        }

        window.clearTimeout(
          resizeTimer
        );

      };

  };



  /* ==================================================
     3. FONDO GLOBAL
     PRODUCTOS + COLECCIONES
     ================================================== */

  const initializeGlobalCodingBackground =
    () => {

      const canvas =
        document.getElementById(
          "CodigosGlobalMatrixCanvas"
        );


      if (!canvas) {
        return;
      }


      initCodigosCodingCanvas(
        canvas
      );

    };


  initializeGlobalCodingBackground();


/* ==================================================
   CÓDIGOS — HEADER LIVE CODING
   ================================================== */

const initializeHeaderCoding = () => {

  const canvas =
    document.getElementById(
      "CodigosHeaderCodingCanvas"
    );

  if (
    !canvas ||
    canvas.dataset.headerCodingInitialized ===
      "true"
  ) {
    return;
  }


  canvas.dataset.headerCodingInitialized =
    "true";


  const context =
    canvas.getContext("2d");


  if (!context) {
    return;
  }


  const snippets = [

    "CODIGOS.initialize();",

    "identity.verify();",

    "ACCESS_GRANTED",

    "style.decode();",

    "SYS://ONLINE",

    "user.auth();",

    "CODE_01",

    "identity = AUTHENTIC;",

    "render.style();",

    "STATUS: ONLINE",

    "AUTH_TOKEN: VALID",

    "decode();",

    "CODIGOS.exe",

    "SYSTEM READY_"

  ];


  const accentColor =
    "#00ff66";


  const grayColor =
    "#686e7d";


  let width = 0;

  let height = 0;

  let pixelRatio = 1;

  let lines = [];

  let animationFrame = null;


  const randomBetween = (
    minimum,
    maximum
  ) => {

    return (
      minimum +
      Math.random() *
      (maximum - minimum)
    );

  };


  const randomSnippet = () => {

    return snippets[
      Math.floor(
        Math.random() *
        snippets.length
      )
    ];

  };


  /* ================================================
     CREA CÓDIGO
     ================================================ */

  const createLine = (
    index = 0
  ) => {

    const isMobile =
      window.innerWidth < 750;


    const fontSize =
      isMobile
        ? randomBetween(8, 10)
        : randomBetween(9, 12);


    const text =
      randomSnippet();


    return {

      text,

      visibleCharacters: 0,


      x:
        randomBetween(
          10,
          Math.max(
            20,
            width - 190
          )
        ),


      y:
        randomBetween(
          14,
          Math.max(
            18,
            height - 8
          )
        ),


      fontSize,


      typingSpeed:
        randomBetween(
          45,
          90
        ),


      deletingSpeed:
        randomBetween(
          18,
          35
        ),


      holdTime:
        randomBetween(
          1000,
          2800
        ),


      startDelay:
        index *
          randomBetween(
            200,
            600
          ) +
        randomBetween(
          0,
          1200
        ),


      lastUpdate:
        performance.now(),


      state:
        "waiting",


      opacity:
        randomBetween(
          0.28,
          0.62
        ),


      useAccent:
        Math.random() > 0.38

    };

  };


  /* ================================================
     CANTIDAD DE LÍNEAS
     ================================================ */

  const createLines = () => {

    let amount;


    if (width < 500) {

      amount = 3;

    } else if (width < 900) {

      amount = 5;

    } else if (width < 1400) {

      amount = 7;

    } else {

      amount = 9;

    }


    lines =
      Array.from(
        {
          length: amount
        },
        (_, index) =>
          createLine(index)
      );

  };


  /* ================================================
     RESIZE
     ================================================ */

  const resizeCanvas = () => {

    const parent =
      canvas.parentElement;


    if (!parent) {
      return;
    }


    pixelRatio =
      Math.min(
        window.devicePixelRatio || 1,
        2
      );


    width =
      parent.offsetWidth;


    height =
      parent.offsetHeight;


    canvas.width =
      Math.floor(
        width *
        pixelRatio
      );


    canvas.height =
      Math.floor(
        height *
        pixelRatio
      );


    canvas.style.width =
      `${width}px`;


    canvas.style.height =
      `${height}px`;


    context.setTransform(
      pixelRatio,
      0,
      0,
      pixelRatio,
      0,
      0
    );


    createLines();

  };


  /* ================================================
     RESET
     ================================================ */

  const resetLine = (
    line
  ) => {

    Object.assign(
      line,
      createLine()
    );


    line.startDelay =
      randomBetween(
        200,
        1300
      );


    line.lastUpdate =
      performance.now();


    line.state =
      "waiting";

  };


  /* ================================================
     DIBUJAR
     ================================================ */

  const draw = (
    timestamp
  ) => {

    context.clearRect(
      0,
      0,
      width,
      height
    );


    lines.forEach(
      (line) => {


        /* ESPERA */

        if (
          line.state ===
          "waiting"
        ) {

          if (
            timestamp -
              line.lastUpdate >=
            line.startDelay
          ) {

            line.state =
              "typing";

            line.lastUpdate =
              timestamp;

          }

        }


        /* ESCRIBE */

        else if (
          line.state ===
          "typing"
        ) {

          if (
            timestamp -
              line.lastUpdate >=
            line.typingSpeed
          ) {

            line.visibleCharacters++;

            line.lastUpdate =
              timestamp;


            if (
              line.visibleCharacters >=
              line.text.length
            ) {

              line.visibleCharacters =
                line.text.length;

              line.state =
                "holding";

              line.lastUpdate =
                timestamp;

            }

          }

        }


        /* MANTIENE */

        else if (
          line.state ===
          "holding"
        ) {

          if (
            timestamp -
              line.lastUpdate >=
            line.holdTime
          ) {

            line.state =
              "deleting";

            line.lastUpdate =
              timestamp;

          }

        }


        /* BORRA */

        else if (
          line.state ===
          "deleting"
        ) {

          if (
            timestamp -
              line.lastUpdate >=
            line.deletingSpeed
          ) {

            line.visibleCharacters -=
              2;


            line.lastUpdate =
              timestamp;


            if (
              line.visibleCharacters <=
              0
            ) {

              resetLine(
                line
              );

              return;

            }

          }

        }


        if (
          line.state ===
            "waiting" ||
          line.visibleCharacters <=
            0
        ) {
          return;
        }


        const visibleText =
          line.text.substring(
            0,
            line.visibleCharacters
          );


        context.save();


        context.font =
          `${line.fontSize}px monospace`;


        context.textAlign =
          "left";


        context.textBaseline =
          "alphabetic";


        context.fillStyle =
          line.useAccent
            ? accentColor
            : grayColor;


        context.globalAlpha =
          line.opacity;


        if (
          line.useAccent
        ) {

          context.shadowColor =
            accentColor;

          context.shadowBlur =
            4;

        }


        context.fillText(
          visibleText,
          line.x,
          line.y
        );


        /* CURSOR */

        if (
          line.state ===
            "typing" &&
          Math.floor(
            timestamp / 450
          ) %
            2 ===
            0
        ) {

          const textWidth =
            context.measureText(
              visibleText
            ).width;


          context.fillStyle =
            accentColor;


          context.globalAlpha =
            Math.min(
              line.opacity +
                0.2,
              0.8
            );


          context.fillRect(
            line.x +
              textWidth +
              2,

            line.y -
              line.fontSize +
              1,

            3,

            line.fontSize
          );

        }


        context.restore();

      }
    );


    animationFrame =
      window.requestAnimationFrame(
        draw
      );

  };


  /* ================================================
     INICIALIZAR
     ================================================ */

  resizeCanvas();


  const reducedMotion =
    window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;


  if (!reducedMotion) {

    animationFrame =
      window.requestAnimationFrame(
        draw
      );

  }


  /* ================================================
     RESPONSIVE
     ================================================ */

  let resizeTimer;


  window.addEventListener(
    "resize",
    () => {

      window.clearTimeout(
        resizeTimer
      );


      resizeTimer =
        window.setTimeout(
          resizeCanvas,
          150
        );

    }
  );

};


initializeHeaderCoding();


})();